'use client';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useTranslation } from 'react-i18next';

interface CurrencySelectorProps {
  selectedCurrency: string;
  onCurrencyChange: (currency: string) => void;
  currencies: string[];
}

export function CurrencySelector({
  selectedCurrency,
  onCurrencyChange,
  currencies,
}: CurrencySelectorProps) {
  const { t } = useTranslation('analytics');
  // Only show if more than 1 currency
  if (currencies.length <= 1) {
    return null;
  }

  return (
    <>
      <span className="hidden text-sm font-medium text-muted-foreground sm:block">{t('filters.currency')}</span>
      <Select value={selectedCurrency} onValueChange={onCurrencyChange}>
        <SelectTrigger className="h-9 w-full sm:w-[120px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {currencies.map((currency: string) => (
            <SelectItem key={currency} value={currency}>
              {currency}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </>
  );
}
